import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'


import {
  fas
} from '@fortawesome/free-solid-svg-icons'

import {
  faGithub
} from '@fortawesome/free-brands-svg-icons'

library.add(
  fas, faGithub
)

Vue.component('fa', FontAwesomeIcon)



// WEBPACK FOOTER //
// ./resources/js/plugins/fontawesome.js